// extracted by mini-css-extract-plugin
module.exports = {"image":"FourImagesGrid-module--image--MCysV","imageWrapper":"FourImagesGrid-module--imageWrapper--2FPgZ"};